import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { arms } from "@/data/content";
import { IyafWordmark } from "@/components/brand/IyafMark";

/**
 * ArmsNav — sticky strip at the bottom of an arm page.
 * Shows the other 3 arms for quick lateral navigation, plus a back-to-overview link.
 */
export default function ArmsNav({ currentKey }) {
  const { t } = useTranslation();
  const others = arms.filter((a) => a.key !== currentKey);

  return (
    <section className="py-12 sm:py-16 bg-iyaf-paper border-t border-black/5" data-testid={`arms-nav-${currentKey}`}>
      <div className="container-iyaf">
        <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
          <div>
            <p className="eyebrow text-iyaf-blue mb-2">{t("armsNav.eyebrow")}</p>
            <h3 className="font-display font-black text-2xl sm:text-3xl">{t("armsNav.title")}</h3>
          </div>
          <Link to="/model" className="text-sm font-semibold text-iyaf-ink/70 hover:text-iyaf-blue inline-flex items-center gap-2">
            {t("armsNav.seeModel")} <ArrowRight size={15} />
          </Link>
        </div>
        <div className="grid sm:grid-cols-3 gap-4">
          {others.map((a) => (
            <Link
              key={a.key}
              to={a.href}
              data-testid={`armsnav-link-${a.key}`}
              className="group relative p-6 rounded-3xl bg-white border border-black/5 hover:border-transparent transition-all overflow-hidden"
            >
              <div className="absolute -right-16 -bottom-16 w-44 h-44 rounded-full opacity-[0.08] group-hover:opacity-100 transition-opacity duration-700" style={{ background: a.color }} />
              <div className="relative">
                <IyafWordmark variant={a.key} size="md" className="mb-3" />
                <p className="text-sm text-iyaf-ink/65 mb-4 line-clamp-2">
                  {t(`armCards.${a.key}.tagline`)} · {a.key === "venture" ? t("armCards.launching", { year: 2027 }) : t("armCards.active")}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: a.color }}>
                  {t("armsNav.explore")} <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
